/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_IdInputs */



/**
* | output |
* | --- |
* | "Id" |
*
* @param {Markers_Export_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_id = /** @type {((inputs?: Markers_Export_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausweis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Id")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор")
	if (locale === "es") return /** @type {LocalizedString} */ ("Identificación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहचान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eu ia")
	return /** @type {LocalizedString} */ ("Id")
});